export default __webpack_public_path__ + "static/media/bedroom2.cc8c97b3.webp";